// Real applications deployed on the DeepMagic platform.
// Keep this file in sync with what's actually running behind Traefik.

const apps = [
  {
    id: 'ai-blog',
    name: 'AI Blog',
    slug: 'ai-blog',
    tagline: 'Read auto-generated AI news with deep research, bilingual EN/zh-TW',
    description:
      'An autonomous newsroom: an AI agent scans sources, writes deeply-researched posts in English and zh-TW, and republishes every 30 minutes. No human editor in the loop.',
    category: 'AI & ML',
    tags: ['AI/LLM', 'Bilingual'],
    status: 'live',
    version: '1.2.0',
    featured: true,
    url: 'https://ai-blog.deepmagic.app',
    image: '/previews/ai-blog.png',
    createdAt: '2026-08-23',
    updatedAt: '2026-08-27',
    stats: { views: 412 }
  },
  {
    id: 'ai-story',
    name: '六界物語',
    slug: 'ai-story',
    tagline: 'Explore an illustrated fantasy saga spanning six realms',
    description:
      'A serialized fantasy story world with an illustrated gallery — worldbuilding, chapters, and art generated and curated with AI.',
    category: 'AI & ML',
    tags: ['AI/LLM', 'React'],
    status: 'live',
    version: '1.1.0',
    featured: false,
    url: 'https://ai-story.deepmagic.app',
    image: '/previews/ai-story.png',
    createdAt: '2026-08-10',
    updatedAt: '2026-08-27',
    stats: { views: 268 }
  }
];

const categories = ['AI & ML'];

const techTags = ['AI/LLM', 'Bilingual', 'React'];

export { apps, categories, techTags };
